<template>
  <blank-view>
    <div slot="action" style="display:flex;align-items: center;justify-content: space-between;">
      <div>
        <a-button @click="exportUtilizationRate">
          {{ $t('export') }}
        </a-button>
      </div>
    </div>
    <div style="display: flex;flex-wrap: nowrap;height: 100%">
      <ml-table
        :columns="columns"
        :dataSource="dataSource"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        size="small"
        :pagination="false"
        :selectRowKey="selectedRow && selectedRow.key"
        :scroll="{ y: scrollY }"
        @change="handleTableChange"
        :customRow="
          (row) => ({
            on: {
              click: () => {
                clickRow(row)
              }
            }
          })"
      >
        <span slot="customTitle">{{ timeName }}</span>
        <div slot="nearly2WeeksPeriodValue" slot-scope="text, record" style="width: 170px;">
          {{ text }}%
          <a-icon
            v-if="text != '0'"
            :style="{
              fontWeight: 'bold',
              color: record.last2rdPeriodValue < record.lastPeriodValue ? '#52C41A' : '#FA554C'
            }"
            :type="record.last2rdPeriodValue < record.lastPeriodValue ? 'arrow-up' : 'arrow-down'"
          />
        </div>
      </ml-table>
      <a-pagination
        style="position:absolute;bottom: 4px;right: 0"
        size="small"
        :total="total"
        :pageSize="filters.size"
        :current="filters.current"
        :show-total="(total) => `${showTotal(total)}`"
        @change="pageIndexchange"
      ></a-pagination>
    </div>
  </blank-view>
</template>

<script>

import { exportUtilizationRate } from "@/api/api";

export default {
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    timeName: {
      type: String,
      default: ''
    },
    filters: {
      type: Object,
      default: () => ({})
    },
    advance: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    dataSource: {
      handler() {
        if (!(this.dataSource && this.dataSource.length)) {
          this.scrollY = 0
          this.selectedRow = {}
          this.selectedRowKeys = []
          return
        }
        this.getScroll()
        const selectRow = this.selectedRow
        this.selectedRow = {}
        if (JSON.stringify(selectRow) === '{}') {
          this.selectedRow = this.dataSource[0]
          this.selectedRowKeys = [this.dataSource[0].key]
        } else {
          const item = this.dataSource.find((res) => res.key === selectRow.key)
          if (item) {
            this.selectedRow = this.dataSource[0]
            this.selectedRowKeys = [this.dataSource[0].key]
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('page_ops_machine_machine_code'),
          dataIndex: 'workStationCode',
          key: 'workStationCode',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_business_device_type'),
          dataIndex: 'deviceTypeName',
          key: 'deviceTypeName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_ops_machine_model_machine_softwareVersion'),
          dataIndex: 'softwareVersion',
          key: 'softwareVersion',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_mdc_customer_name'),
          dataIndex: 'customerName',
          key: 'customerName',
          width: 120,
          ellipsis: true
        },
        {
          title: this.$t('page_mdc_two_week_ago'),
          dataIndex: 'last2rdPeriodValue',
          key: 'last2rdPeriodValue',
          width: 80,
          sorter: true,
          ellipsis: true,
          customRender: (text) => {
            return <span>{text}%</span>
          }
        },
        {
          title: this.$t('page_mdc_one_week_ago'),
          dataIndex: 'lastPeriodValue',
          key: 'lastPeriodValue',
          width: 80,
          ellipsis: true,
          sorter: true,
          customRender: (text) => {
            return <span>{text}%</span>
          }
        },
        {
          title: this.$t('page_mdc_change_two_week'),
          dataIndex: 'nearly2WeeksPeriodValue',
          key: 'nearly2WeeksPeriodValue',
          width: 120,
          ellipsis: true,
          sorter: true,
          scopedSlots: { customRender: 'nearly2WeeksPeriodValue' }
        },
        {
          dataIndex: 'dynamicPeriodValue',
          slots: { title: 'customTitle' },
          key: 'dynamicPeriodValue',
          width: 220,
          ellipsis: true,
          defaultSortOrder: 'descend',
          sorter: true,
          customRender: (text) => {
            return <span>{Number(text).toFixed(2)}%</span>
          }
        }
      ],
      selectedRow: {}, // 编辑数据
      selectedRowKeys: [], // 选中ids
      scrollY: 0
    }
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      this.$emit('sorter', {sortField:sorter.field, sortOrder: sorter.order || ""})
    },
    getScroll() {
      const devCol = document.documentElement
      const scrollY = devCol.clientHeight - 210
      const lengthHieght = this.dataSource.length * 35
      if (scrollY < lengthHieght) {
        this.scrollY = scrollY
      }
    },
    pageIndexchange(value) {
      this.$emit('pageIndexchange', value)
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    onSelectChange(keys) {
      this.selectedRowKeys = keys
    },
    clickRow(row) {
      this.selectedRow = row
      this.selectedRowKeys = [row.key]
    },
    exportUtilizationRate() {
      this.advance.idList = this.selectedRowKeys
      exportUtilizationRate(this.advance).then((res) => {
        // 创建隐藏的可下载链接
        var a = document.createElement("a")
        a.download = `${this.$t('page_time_analysis_oee')}.xlsx`
        a.style.display = "none"
        // 字符内容转变成blob地址
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      });
    },
  }
}
</script>

<style lang="less" scoped>
.exception {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  padding-bottom: 240px;
  .text {
    padding: 24px;
    p {
      font-size: 20px;
    }
  }
}
.custom-list {
  width: 100%;
  position: relative;
}
</style>
